export default __webpack_public_path__ + "static/media/BLACK_PANTHER.c068ecbe.png";